import { render, staticRenderFns } from "./ChooseSimulation.vue?vue&type=template&id=3e35452b&scoped=true&"
import script from "./ChooseSimulation.vue?vue&type=script&lang=js&"
export * from "./ChooseSimulation.vue?vue&type=script&lang=js&"
import style0 from "./ChooseSimulation.vue?vue&type=style&index=0&id=3e35452b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e35452b",
  null
  
)

export default component.exports